import React from 'react';
import { AuthSessionProvider } from './AuthSessionProvider';


export default function LayoutAdmin({ children }) {
  return (
    <AuthSessionProvider>
      <div className="min-h-screen flex">
        <aside className="w-64 bg-gray-100 p-4">
          <nav className="space-y-2">
            <a href="/admin/a" className="block p-2 hover:bg-gray-200 rounded">Page A</a>
            <a href="/admin/b" className="block p-2 hover:bg-gray-200 rounded">Page B</a>
          </nav>
        </aside>
        <div className="flex-1">
          <header className="bg-white shadow">
            <nav className="container mx-auto px-4 py-4">
              <h1 className="text-xl font-bold">Admin Header</h1>
            </nav>
          </header>
          <main className="container mx-auto px-4 py-8">
            {children}
          </main>
        </div>
      </div>
    </AuthSessionProvider>
  );
};


